import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alfred",
  "use": "alfred-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"alfred\"><path d=\"M10 4c3.728 0 6.75 2.518 6.75 5.625l.001 1.37c1.4.596 2.249 1.377 2.249 2.233 0 1.864-4.03 3.375-9 3.375s-9-1.511-9-3.375c0-.856.85-1.638 2.25-2.233v-1.37l.004-.206C3.384 6.408 6.354 4 10 4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol